import { CommonProductQueryParams } from '~/api/easy-estimator-api/commonProductQueryParams';
import { easyEstimatorApi } from '~/api/easy-estimator-api/easyEstimatorService';
import { ApiUrl } from '~/core/enums';
import { EdgeModel } from '~/core/models';

/**
 * @todo very similar to materials. This may be abstracted further.
 */
const edgesService = easyEstimatorApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchEdges: builder.query<EdgeModel[], CommonProductQueryParams>({
      query: ({ params }) => ({
        url: ApiUrl.EDGES,
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const { useFetchEdgesQuery, useLazyFetchEdgesQuery } = edgesService;
